import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import { getCurrentNonHiddenPortalCount } from 'state/selectors/featured-and-sorted-portals/featured-and-sorted-portals';
import { getDefaultViewLoading } from 'state/selectors/featured-and-sorted-portals';
import HelpCenterTopics from './help-center-topics';

const selector = createSelector(
    getDefaultViewLoading,
    getCurrentNonHiddenPortalCount,
    (isDefaultViewLoaded, currentNonHiddenPortals) => ({
        isDefaultViewLoading: isDefaultViewLoaded,
        shouldAlignWithHelpCenterContainer: currentNonHiddenPortals === 1,
    })
);

export default connect(selector, {})(HelpCenterTopics);
